import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  padding = 0;
  previousUrl: string = null;
  currentUrl: string = null;
  changed: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  offset = {
    '': 0,
    inicio: 0,
    'sobre-mi': 0,
    experiencia: 0,
    areas: 0,
    contacto: 0
  };
  onHideNavbar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  onHideFooter: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private router: Router, private route: ActivatedRoute) {
    router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url.substr(1);
        this.changed.next(true);
      });
  }

  scrollCurrentRoute(): void {
    this.scrollSection(this.currentUrl);
  }

  scrollSection(route: string): void {
    this.changed.next(true);
    let scrollTop = this.offset[route];

    const routeBehavior = {
      '': 'smooth',
      inicio: 'smooth',
      'sobre-mi': 'smooth',
      experiencia: 'smooth',
      areas: 'smooth',
      contacto: 'smooth'
    };

    const behavior =
      this.previousUrl === null
        ? this.currentUrl === 'otro' || this.currentUrl === ''
          ? 'auto'
          : 'smooth'
        : this.previousUrl === 'otro'
        ? 'auto'
        : routeBehavior[this.currentUrl];

    if (this.currentUrl !== '' && this.currentUrl !== 'otro') {
      scrollTop -= this.padding;
    } else {
      scrollTop = 0;
    }

    window.scroll({
      top: scrollTop,
      left: 0,
      behavior
    });
  }

  hideNavbar(flag: boolean): void {
    this.onHideNavbar.next(flag);
  }

  hideFooter(flag: boolean): void {
    this.onHideFooter.next(flag);
  }
}
